// extracted by mini-css-extract-plugin
module.exports = {"BooksLoading":"BooksLoading_BooksLoading__24_D8","BooksLoading_Icon":"BooksLoading_BooksLoading_Icon__nsCVH"};